import React, { useState } from 'react';
import { theme } from '../components/theme';

export const FeatureCard = ({
  title,
  description,
  icon: Icon,
  iconBgColor,
  iconColor,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        backgroundColor: theme.colors.neutral.white,
        borderRadius: theme.borderRadius.xl,
        padding: theme.spacing.xl,
        textAlign: 'center',
        minHeight: '280px',
        boxShadow: isHovered ? theme.shadows.xl : theme.shadows.lg,
        transform: isHovered ? 'translateY(-4px)' : 'translateY(0)',
        transition: `all ${theme.transitions.base}`,
        border: `1px solid ${theme.colors.neutral.gray100}`,
      }}
    >
      <div
        style={{
          width: '80px',
          height: '80px',
          backgroundColor: iconBgColor,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: `0 auto ${theme.spacing.lg}`,
          transform: isHovered ? 'scale(1.1) rotate(5deg)' : 'scale(1)',
          transition: `all ${theme.transitions.base}`,
        }}
      >
        <Icon size={36} color={iconColor} strokeWidth={2} />
      </div>

      <h4
        style={{
          fontSize: theme.typography.fontSize.xl,
          fontWeight: theme.typography.fontWeight.bold,
          color: theme.colors.primary.navy,
          marginBottom: theme.spacing.md,
          lineHeight: theme.typography.lineHeight.tight,
        }}
      >
        {title}
      </h4>

      <p
        style={{
          fontSize: theme.typography.fontSize.base,
          color: theme.colors.primary.blue,
          lineHeight: theme.typography.lineHeight.relaxed,
          margin: 0,
        }}
      >
        {description}
      </p>
    </div>
  );
};
